import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import SpineWrapper from '@Core/Animation/SpineWrapper';
import { GameComponent } from '@Core/GameComponent/GameComponent';
import { GameScene } from '@Core/GameScene/GameScene';
import { StaticJackpotLadder } from '@Core/StaticJackpotLadder/StaticJackpotLadder';
import { StaticJackpotMaxWinText } from '@Core/StaticJackpotMaxWinText/StaticJackpotMaxWinText';
import { IMaxWinFeature } from '@GFTypes/GameStoreTypes';
import { ELayeringOrder } from '@GFTypes/LayeringOrder';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';

export class ReelsBackground extends GameComponent {
    static readonly SPINE_KEY: string = 'reels';
    static readonly SKIN_NAME: string = 'default';
    static readonly REEL_SLOT_PREFIX: string = 'reel_placeholder_';
    static readonly ALTERNATIVE_SLOT_PREFIX: string = 'LR_reel_placeholder_';

    public scene: GameScene;
    private reelsSpine: SpineWrapper;
    private readonly staticJackpotInfo: IMaxWinFeature | undefined;
    private staticJackpotMaxWinText: StaticJackpotMaxWinText;

    constructor(scene: GameScene, maxWin?: IMaxWinFeature) {
        super(scene);
        this.scene = scene;
        Logger.log(LoggerLevel.Constructor, {
            source: LoggerSource.Game,
            message: 'ReelsBackground constructor'
        });
        if (maxWin) this.staticJackpotInfo = maxWin;
    }

    public onCreate(): void {
        this.reelsSpine = new SpineWrapper(
            this.scene,
            {
                x: this.scene.screen.width / 2,
                y: this.scene.screen.height / 2
            },
            { dataKey: ReelsBackground.SPINE_KEY, skinName: ReelsBackground.SKIN_NAME, manuallyScaleOnResize: true },
            true
        );

        this.reelsSpine.spine.zIndex = ELayeringOrder.REELS_BACKGROUND;
        this.reelsSpine.forceUpdate();

        if (this.staticJackpotInfo?.maxWin)
            this.staticJackpotMaxWinText = new StaticJackpotMaxWinText(this.scene, this.reelsSpine, this.staticJackpotInfo.maxWin);
        if (ConfigLoader.getConfiguration(EConfigurationNames.GAME).staticJackpotLadderSymbol)
            new StaticJackpotLadder(this.scene, this.reelsSpine, ConfigLoader.getConfiguration(EConfigurationNames.GAME).staticJackpotLadderSymbol);
        this.scene.game.scaleManager.addReelsSpine(this.scene, this.reelsSpine);
    }

    public getReelsSpine(): SpineWrapper {
        return this.reelsSpine;
    }
}
